/* eslint-disable import/no-unresolved */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Image } from 'react-bootstrap'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function MoveinPreview({ srcs, isMediaVisible, redirectUrl }) {
  const containerRef = useRef(null)
  const leftSwiperRef = useRef(null)
  const rightSwiperRef = useRef(null)
  const [leftIndex, setLeftIndex] = useState(0)
  const [rightIndex, setRightIndex] = useState(0)
  const wheelLockRef = useRef(false)

  const backgroundImg = srcs.find((s) => s.label === 'Background Img')
  const leftImg1 = srcs.find((s) => s.label === 'Left 1')
  const leftImg2 = srcs.find((s) => s.label === 'Left 2')
  const rightImg1 = srcs.find((s) => s.label === 'Right 1')
  const rightImg2 = srcs.find((s) => s.label === 'Right 2')

  const getPreviewURL = (file) => {
    if (file instanceof File) return URL.createObjectURL(file)
    if (typeof file === 'string' && file.startsWith('blob:')) return file
    return `/api/file/${file}`
  }

  const handleWheel = (e) => {
    if (wheelLockRef.current) return

    wheelLockRef.current = true
    setTimeout(() => {
      wheelLockRef.current = false
    }, 1000)

    if (!leftSwiperRef.current || !rightSwiperRef.current) return

    if (e.deltaY > 0) {
      leftSwiperRef.current.swiper.slideNext()
      rightSwiperRef.current.swiper.slideNext()
    } else if (e.deltaY < 0) {
      leftSwiperRef.current.swiper.slidePrev()
      rightSwiperRef.current.swiper.slidePrev()
    }
  }

  return (
    <div
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
      onWheel={handleWheel}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '2%' }}
        />
        <div style={{ position: 'relative' }}>
          <div
            className="border-bottom mb-3 d-flex"
            style={{ width: '240px', height: '55px', zIndex: '0' }}
          >
            <div className="w-80 m-auto ms-auto">
              <Image src={wavenet_logo} className="w-75 ps-3" />
            </div>
            <div className="w-20 m-auto ms-auto d-flex">
              <FontAwesomeIcon icon={faBars} className="text-end" />
            </div>
          </div>
          <div className="text-title" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-ban1" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line2" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
        </div>
      </div>
      <div
        style={{
          objectFit: 'cover',
          height: 'auto',
          position: 'absolute',
          bottom: '12%',
          width: '240px',
          zIndex: '1000',
        }}
      >
        <div
          ref={containerRef}
          className="position-relative"
          style={{
            width: '240px',
            minHeight: 'auto',
            margin: '0 auto',
          }}
        />
      </div>
      <div style={{ position: 'relative' }}>
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>

      <div
        style={{
          position: 'absolute',
          bottom: '11%',
          width: '240px',
          zIndex: 1000,
        }}
      >
        {isMediaVisible && backgroundImg?.file && (
          <>
            <img
              src={getPreviewURL(backgroundImg.file)}
              alt="BackgroundImg"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block',
              }}
            />
            <CIIcon />
          </>
        )}

        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '50%',
            height: '100%',
            zIndex: 1100,
          }}
        >
          <Swiper
            ref={leftSwiperRef}
            loop
            modules={[Autoplay]}
            autoplay={{ delay: 2000, disableOnInteraction: false }}
            slidesPerView={1}
            onSlideChange={(swiper) => setLeftIndex(swiper.realIndex)}
          >
            {[leftImg1, leftImg2].map(
              (img, i) =>
                img?.file && (
                  <SwiperSlide key={`left-${i}`}>
                    <a
                      href={redirectUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={getPreviewURL(img.file)}
                        alt={`Left ${i + 1}`}
                        className={`movein-slide-img ${
                          leftIndex === i ? 'slide-in-left' : 'slide-out-left'
                        }`}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                        }}
                      />
                    </a>
                  </SwiperSlide>
                )
            )}
          </Swiper>
        </div>

        <div
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '50%',
            height: '100%',
            zIndex: 1100,
          }}
        >
          <Swiper
            ref={rightSwiperRef}
            loop
            modules={[Autoplay]}
            autoplay={{ delay: 2000, disableOnInteraction: false }}
            slidesPerView={1}
            onSlideChange={(swiper) => setRightIndex(swiper.realIndex)}
          >
            {[rightImg1, rightImg2].map(
              (img, i) =>
                img?.file && (
                  <SwiperSlide key={`right-${i}`}>
                    <a
                      href={redirectUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={getPreviewURL(img.file)}
                        alt={`Right ${i + 1}`}
                        className={`movein-slide-img ${
                          rightIndex === i
                            ? 'slide-in-right'
                            : 'slide-out-right'
                        }`}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                        }}
                      />
                    </a>
                  </SwiperSlide>
                )
            )}
          </Swiper>
        </div>
      </div>
    </div>
  )
}

MoveinPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      label: PropTypes.string,
    })
  ),
  isMediaVisible: PropTypes.bool.isRequired,
  redirectUrl: PropTypes.string,
}

MoveinPreview.defaultProps = {
  srcs: [],
  redirectUrl: '',
}

export default MoveinPreview
